// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-jmJ","field":"styles_field__17obq","fieldCol":"styles_fieldCol__1ebC3","diffCol":"styles_diffCol__3uXZV","diff":"styles_diff__2WQWD"};